module.exports = __webpack_public_path__ + "static/media/blog26.9bff56c3.webp";